var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-medium"},[_vm._v("CODATA - WEB: "+_vm._s(_vm.versao)+" - API: "+_vm._s(_vm.versaoApi))])}
var staticRenderFns = []

export { render, staticRenderFns }